import React from 'react';
import { Menu } from "antd";
import { Link } from "react-router-dom";
import { HomeOutlined, InfoCircleOutlined, QuestionCircleOutlined, UserAddOutlined, UserOutlined} from "@ant-design/icons";

const Vendor = (props) => {
  return (
    <Menu {...props}>
      <Menu.Item key="dashboard">
        <Link to="/dashboard">
          <HomeOutlined />
          <span>Home</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="passport/register">
        <Link to="/passport/register">
          <UserAddOutlined />
          <span>Registrasi</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="passport">
        <Link to="/passport">
          <UserOutlined />
          <span>Personel Data</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="about">
        <Link to="/about">
          <InfoCircleOutlined />
          <span>Tentang Kami</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="faq">
        <Link to="/faq">
          <QuestionCircleOutlined />
          <span>FAQ</span>
        </Link>
      </Menu.Item>
    </Menu>
  );
}

export default Vendor;